import { useMemo } from 'react';
import { SelfUpgradeActionType } from '../constants/self-upgrade';
import { useFeatureSubscription } from '../providers/FeatureSubscriptionProvider';
import { getActionIconName, getActionText } from '../self-upgrade.util';
import { useFeatureUpgradeDetailsModal } from './useFeatureUpgradeDetailsModal';

export const useGetSelfUpgradeAction = () => {
  const {
    feature,
    hasAdminAccessInAtLeastOne,
    isFreeTrialEligible,
    isUpgradeEligible,
    isBundleUpgradeEligible,
    subscriptionDataList,
    isLoading,
  } = useFeatureSubscription();

  const { FeatureUpgradeDetailsModal } = useFeatureUpgradeDetailsModal({ feature, isBundleUpgradeEligible });
  const hasFeatureUpgradeDetailModal = !!FeatureUpgradeDetailsModal;
  const isMultiUpgrade = subscriptionDataList.length > 1;

  const actionType = useMemo<SelfUpgradeActionType>(() => {
    if (!isUpgradeEligible && !isFreeTrialEligible) {
      return SelfUpgradeActionType.NONE;
    } else if (!hasFeatureUpgradeDetailModal) {
      return SelfUpgradeActionType.SCHEDULE_CALL;
    } else if (!hasAdminAccessInAtLeastOne && !isMultiUpgrade) {
      return SelfUpgradeActionType.REQUEST_UPGRADE;
    } else if (isFreeTrialEligible || isBundleUpgradeEligible) {
      return SelfUpgradeActionType.FREE_TRIAL;
    } else if (isUpgradeEligible) {
      return SelfUpgradeActionType.UPGRADE_NOW;
    } else {
      return SelfUpgradeActionType.NONE;
    }
  }, [
    hasAdminAccessInAtLeastOne,
    isFreeTrialEligible,
    isUpgradeEligible,
    hasFeatureUpgradeDetailModal,
    isMultiUpgrade,
    isBundleUpgradeEligible,
  ]);

  const actionTextData = getActionText(actionType, feature);
  const actionIconName = getActionIconName(actionType);

  return {
    isLoading,
    actionType,
    actionTextData,
    actionIconName,
  };
};
